import Api from '../http.service';
/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 */
export const getAll = (payload) =>
  Api.GET({
    url: `dashboard/profile/${payload.pageNumber - 1}/${payload.itemPerPage}`,
  });

/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 */
export const getAllNews = (payload) =>
  Api.GET({
    url: `/news/all?page=${payload.pageNumber - 1}&size=${
      payload.itemPerPage
    }&order=asc`,
  });
/**
 * @param {Object} payload
 * @param {String} payload.pageNumber
 * @param {String} payload.itemPerPage
 * @param {Number} payload.profileId
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getRecentFlights = (payload) =>
  Api.GET({
    url: `customer/flight/booking/all?size=${payload.itemPerPage}&page=${
      payload.pageNumber - 1
    }&where=${payload.data.filter}`,
  });
/**
 * @param {Object} payload
 * @param {String} payload.pageNumber
 * @param {String} payload.itemPerPage
 * @param {Number} payload.profileId
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getCountOrder = (payload) =>
  Api.GET({
    url: `/booking/count_user_order?size=${payload.itemPerPage}&page=${
      payload.pageNumber - 1
    }&where=${payload.data.filter}`,
  });

/**
 * @param {Object} payload
 * @param {String} payload.data.orderDate
 */
export const getHistoryTrip = (payload) =>
  Api.GET({
    url: `/customer/flight/booking/historyTrip?orderDate=${payload.data.orderDate}&limit=${payload.data.limit}`,
  });

/**
 * @param {Object} payload
 * @param {String} payload.data.orderDate
 */
export const getDestinationTrip = (payload) =>
  Api.GET({
    url: `/customer/flight/booking/destinationTrip?orderDate=${payload.data.orderDate}&limit=${payload.data.limit}`,
  });
